export default __webpack_public_path__ + "static/media/bg-genuin.325653eb.png";